export class OpenShellAgentBuilder {
    pluginConfig;
    policyJson = null;
    skills = [];
    providers;
    skillRefs;
    slack;
    discord;
    telegram;
    constructor(folder_id, model_id) {
        this.pluginConfig = {
            folder_id,
            model_id
        };
        this.providers = new Set();
        this.skillRefs = [];
    }
    addCollectionId(id) {
        this.pluginConfig.collection_id = id;
        return this;
    }
    addDatasetId(id) {
        this.pluginConfig.dataset_id = id;
        return this;
    }
    addProjectId(id) {
        this.pluginConfig.project_id = id;
        return this;
    }
    addMCPUrl(url) {
        this.pluginConfig.mcp_url = url;
        return this;
    }
    addApiKey(key) {
        this.pluginConfig.api_key = key;
        return this;
    }
    addSkill(name, skill) {
        if (!skill)
            return this;
        this.skills.push({ name, content: skill });
        return this;
    }
    addPolicyJson(policy) {
        this.policyJson = policy;
        return this;
    }
    addProvider(provider) {
        this.providers.add(provider);
        return this;
    }
    addSlackConfig(config) {
        this.slack = config;
        return this;
    }
    addDiscordConfig(config) {
        this.discord = config;
        return this;
    }
    addTelegramConfig(config) {
        this.telegram = config;
        return this;
    }
    addSkillRefs(skillRefs) {
        const retSkillRefs = (skillRefs ?? []).map((skillString) => ({ id: skillString }));
        this.skillRefs = [...retSkillRefs];
        return this;
    }
    buildLaunchRequestOpts = {
        useAibleSkill: true
    };
    buildLaunchRequest(name, options = this.buildLaunchRequestOpts, moreOptions) {
        const opts = { ...options, ...this.buildLaunchRequestOpts };
        const openclawPlugins = [];
        if (moreOptions?.useAibleSkill === true) {
            openclawPlugins.push({
                type: "aible",
                config: {
                    folder_id: this.pluginConfig.folder_id,
                    collection_id: this.pluginConfig.collection_id,
                    model_id: this.pluginConfig.model_id,
                    mcp_url: this.pluginConfig.mcp_url,
                    api_key: this.pluginConfig.api_key
                }
            });
        }
        if (moreOptions?.useAibleSkillWorkflow === true) {
            openclawPlugins.push({
                type: "aible_skill_workflow",
                config: {
                    folder_id: this.pluginConfig.folder_id,
                    model_id: this.pluginConfig.model_id,
                    mcp_url: this.pluginConfig.mcp_url,
                    api_key: this.pluginConfig.api_key
                }
            });
        }
        return {
            name,
            metadata: {
                folder_id: this.pluginConfig.folder_id,
                model_id: this.pluginConfig.model_id,
                collection_id: this.pluginConfig.collection_id
            },
            openclaw: {
                plugins: openclawPlugins,
                skills: this.skills,
                ...(this.skillRefs.length > 0 ? { skill_refs: [...this.skillRefs] } : {}),
                ...(this.slack ? { slack: this.slack } : {}),
                ...(this.discord ? { discord: this.discord } : {}),
                ...(this.telegram ? { telegram: this.telegram } : {})
            },
            ...(this.policyJson ? { policy_json: this.policyJson } : {}),
            ...(moreOptions?.webSearch?.isEnabled === true
                ? { web_search: { provider: "brave", api_key: moreOptions?.webSearch?.braveApiKey } }
                : {}),
            ...(this.providers.size > 0 ? { providers: [...this.providers] } : {})
        };
    }
}
